import { render, staticRenderFns } from "./SignInOrOutToolbarButton.vue?vue&type=template&id=3c7c9c7e&"
import script from "./SignInOrOutToolbarButton.vue?vue&type=script&lang=js&"
export * from "./SignInOrOutToolbarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports